import type { PaginationOptions } from "../domain/pagination";
import type { CreateReferenceInput } from "../domain/reference";
import {
  createReferenceAPI,
  deleteReferenceAPI,
  fetchOneReferenceAPI,
  fetchReferencesAPI,
  generateReferenceDatabaseAPI,
  publishReferenceAPI,
  searchReferencesAPI,
  updateReferenceAPI,
} from "../infrastructure/reference.api";
import {
  type GeneratedReference,
  type Reference,
  formatFromReferenceToGeneratedReference,
} from "../infrastructure/reference.formatter";
import type { ApiRequestResponse } from "../shared/http-client";

export default function createReference(reference: CreateReferenceInput): Promise<Reference> {
  return createReferenceAPI(reference);
}

export async function fetchReferences(
  options: PaginationOptions,
): Promise<ApiRequestResponse<Reference[]>> {
  return await fetchReferencesAPI(options);
}

export async function searchReferences(query: string): Promise<Reference[]> {
  return await searchReferencesAPI(query);
}

export async function fetchOneReference(id: number): Promise<Reference> {
  return await fetchOneReferenceAPI(id);
}

export async function fetchOneGeneratedReference(
  id: number,
): Promise<GeneratedReference | undefined> {
  return formatFromReferenceToGeneratedReference(await fetchOneReferenceAPI(id));
}

export async function updateReference(
  referenceId: number,
  input: CreateReferenceInput,
): Promise<Reference> {
  return await updateReferenceAPI(referenceId, input);
}

export async function deleteReference(referenceId: number): Promise<void> {
  await deleteReferenceAPI(referenceId);
}

export function publishReference(referenceId: number): Promise<void> {
  return publishReferenceAPI(referenceId);
}

export function generateReferenceDatabase(referenceId: number): Promise<void> {
  return generateReferenceDatabaseAPI(referenceId);
}
